import { render, staticRenderFns } from "./InactivityModal.vue?vue&type=template&id=15428c7a"
import script from "./InactivityModal.vue?vue&type=script&lang=js"
export * from "./InactivityModal.vue?vue&type=script&lang=js"
import style0 from "./InactivityModal.vue?vue&type=style&index=0&id=15428c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports